export default __webpack_public_path__ + "static/media/Hegde.0e5f6ffb.png";